export default {
      id: "mission-security-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "img/icons.ece5aa3c.svg#mission-security",
      toString: function () {
        return this.url;
      }
    }